import * as Yup from "yup";
import validationUtils from "./ValidationUtils.js";

const loginSchema = Yup.object().shape({
  email: validationUtils?.validateEmail(),
  password: validationUtils?.validatePassword(),
});

export default loginSchema;
